var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Grid, Accordion, AccordionSummary, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
var StyledAccordion = styled(Accordion)(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: theme.palette.background.paper,
        '&.MuiAccordion-root': {
            border: 'none',
            borderBottom: "1px solid ".concat(theme.palette.neutral[80]),
            color: theme.palette.text.primary,
            '&.Mui-disabled:last-child': {
                borderBottom: 0,
            },
        },
        '&.Mui-expanded': {
            margin: 0,
        },
        '&.AccordionHeader.Mui-disabled': __assign({ backgroundColor: theme.palette.background.light, color: theme.palette.text.primary }, theme.typography.labelLarge),
        '&.AccordionHeader.Mui-disabled .MuiAccordionSummary-root': {
            opacity: 1,
        },
        '&:not(.AccordionHeader):not(.Mui-disabled) .MuiAccordionSummary-root ': {
            backgroundColor: theme.palette.background.paper,
        },
        '&.AccordionHeader .MuiAccordionSummary-expandIconWrapper': {
            visibility: 'hidden',
        },
        '@media (max-width: 599.99px)': {
            overflowY: 'hidden',
            border: 'none',
            width: '800px',
        },
    });
});
var ExpansionSummaryHeader = styled(Grid)(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: "".concat(theme.typography.fontSize, "px"),
        lineHeight: theme.typography.body1.lineHeight,
        '&.Mui-expanded': {
            borderBottom: 'none',
        },
    });
});
var ExpansionDataPoint = styled(Grid)(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: "".concat(theme.typography.fontSize, "px"),
        lineHeight: theme.typography.body1.lineHeight,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '50px',
    });
});
var ExpansionHeaderContainer = styled(Grid)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: "0 ".concat(theme.spacing(2), " ").concat(theme.spacing(1), " ").concat(theme.spacing(7)),
    });
});
var ExpansionHeaderPoint = styled(Grid)(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: "".concat(theme.typography.fontSize, "px"),
        lineHeight: theme.typography.caption.lineHeight,
        letterSpacing: '2px',
    });
});
var StyledAccordionSummary = styled(AccordionSummary)(function (_a) {
    var theme = _a.theme;
    return ({
        flexDirection: 'row-reverse',
        width: '100%',
        '& .MuiAccordionSummary-content': {
            marginRight: theme.spacing(2),
            marginLeft: theme.spacing(2),
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
            marginRight: theme.spacing(2),
            marginLeft: theme.spacing(2),
        },
        '&.Mui-expanded': {
            height: '56px',
            minHeight: 'auto',
        },
        '@media (max-width: 599.99px)': {
            overflowY: 'hidden',
            border: 'none',
            width: '800px',
        },
    });
});
var AccordionHeader = styled(AccordionSummary)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(1),
    });
});
var ExpansionRowContainer = styled(Grid)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(1),
        minHeight: '58px',
        paddingLeft: "".concat(theme.spacing(7)),
        paddingRight: "".concat(theme.spacing(4)),
    });
});
var ExpansionRowHeader = styled(Grid)(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: "".concat(theme.typography.fontSize, "px"),
        display: 'flex',
        alignItems: 'center',
    });
});
var ExpansionRowLabel = styled(Typography)(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: "".concat(theme.typography.fontSize, "px"),
        lineHeight: theme.typography.caption.lineHeight,
    });
});
export { StyledAccordion, ExpansionSummaryHeader, ExpansionDataPoint, ExpansionHeaderContainer, ExpansionHeaderPoint, StyledAccordionSummary, AccordionHeader, ExpansionRowContainer, ExpansionRowHeader, ExpansionRowLabel, };
